import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { requestNotificationPermission, subscribeToPush, isPushSupported } from './notifications';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/service-worker.js');
      console.log('SW registered:', registration.scope);

      // Once the user is logged in, set up push notifications
      if (localStorage.getItem('token') && isPushSupported()) {
        const permission = await requestNotificationPermission();
        if (permission === 'granted') {
          await subscribeToPush();
        }
      }
    } catch (err) {
      console.warn('SW registration failed:', err);
    }
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
